import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        role: {},
        roles: {data: [], current_page: 1, total: 0, per_page: 10},
        role_permissions: {data: [], current_page: 1, total: 0, per_page: 10},
        errors: {
            data: {
                errors: {
                    name: [],
                    description: []
                }
            }
        },
        has_errors: false,
        dialogVisible: false,
        loading: false
    },
    getters: {
        dialogVisible: state => state.dialogVisible,
        roles: state => state.roles,
        role: state => state.role,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        loading: state => state.loading,
        role_permissions: state => state.role_permissions
    },
    mutations: {
        setRolePermissions(state, data) {
            state.role_permissions = data;
        },
        setRoles(state, data) {
            state.roles = data;
        },
        setRole(state, data) {
            state.role = data;
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            name: [],
                            description: []
                        }
                    }
                };
            }
        }
    },
    actions: {
        async getRoles({commit}, filters) {
            try {
                commit('setLoading', true)
                const response = await api.getRoles(filters);
                commit('setRoles', response);
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error({
                    message: e.response.data.message,
                    duration: 10000
                });
            }
        },
        async getRole({commit}, data) {
            try {
                commit('activateLoading', 'role/list', {root: true});
                const response = await api.getRole(data);
                commit('setRole', response?.data);
                commit('deactivateLoading', 'role/list', {root: true});
            } catch (e) {
                commit('deactivateLoading', 'user/list', {root: true})
                ElMessage.error({
                    message: e.response.data.message,
                    duration: 10000
                });
            }
        },
        async createRole({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.createRole(data);
                ElMessage.success({
                    message: 'Role created successfully!',
                    duration: 10000
                });
                commit('setLoading', false)
                commit('setDialogVisible', false)
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: e.response.data.message,
                    duration: 10000
                });
            }
        },

        async editRole({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.editRole(data)
                ElMessage.success({
                    message: 'Role updated successfully!',
                    duration: 10000
                });
                commit('setLoading', false)
                commit('setDialogVisible', false)
                dispatch('getRoles', {
                    paginate: true
                })
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: e.response.data.message,
                    duration: 10000
                });
            }
        },
        openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

        async getRolePermissions({commit}, data) {
            try {
                commit('activateLoading', 'permissions/list', {root: true});
                const response = await api.getRolePermissions(data);
                // Normalize status (comes back from the API as 1/0, not a real
                // boolean) here, before it ever reaches reactive state - doing
                // this later by mutating already-committed state is what caused
                // the el-switch toggles to not reflect it until a manual refresh.
                if (response.data) {
                    response.data = response.data.map(group => group.map(perm => ({
                        ...perm,
                        status: perm.status === 1 || perm.status === true || perm.status === '1',
                    })));
                }
                commit('setRolePermissions', response);
                commit('deactivateLoading', 'permissions/list', {root: true});

            } catch (e) {
                commit('deactivateLoading', 'permissions/list', {root: true});
                ElMessage.error(
                    {
                        message: e.response.data.message,
                        duration: 10000
                    });
            }
        },
        async saveRolePermissions({commit, dispatch}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.saveRolePermissions(data);
                commit('setLoading', false)
                ElMessage.success({
                    message: 'Role Permissions added successfully!',
                    duration: 10000
                });
                window.location.href = '/roles'
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: e.response.data.message,
                    duration: 10000
                });
            }
        },
        async deleteRole({dispatch, commit}, data) {
            try {
                commit('hasErrors', false);
                const response = await api.deleteRole(data);
                dispatch('getRoles', {
                    paginate: true
                });
                if (response.status === 401) {
                    ElMessage.warning({
                        message: response.message,
                        duration: 10000
                    });
                } else {
                    ElMessage.success({
                        message: response.message,
                        duration: 10000
                    });
                }
            } catch (e) {
                commit('hasErrors', true);
                commit('setErrors', e.response)
                ElMessage.error({
                    message: e.response.data.message,
                    duration: 10000
                });
            }
        },

        async exportRolesReport({commit}, {filters, format}) {
            try {
                commit('setLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportRolesReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Roles_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },


    }
}
